// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FundraiserCard_container__EoPnF{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 257px;
    padding: 24px 24px 32px 24px;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.FundraiserCard_name__MEA8m{
    max-width: 100%;
    margin-top: 0;
    margin-bottom: 8px;
    text-align: center;
    color: #40798C;
    font-size: 16px;
    font-family: 'Gotham Bold', serif;
    line-height: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.FundraiserCard_requestPendingStatus__KNGmk{
    margin: 11px 0;
    color: #EB443F;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
.FundraiserCard_exclamationCircleRed__ijU4g{
    position: relative;
    top: 1px;
    height: 12px;
    width: 12px;
    margin-right: 5px;
}
.FundraiserCard_status__OfCLQ{
    margin-bottom: 10px;
    padding: 6px 12px;
    font-size: 12px;
    font-family: 'Gotham Medium', serif;
    border: 1px solid;
    border-radius: 14px;
}
.FundraiserCard_notStarted__5znOd{
    color: #40798C;
    background-color: #ECF2F4;
    border-color: #DBE6EA;
}
.FundraiserCard_inProgress__4dpkS{
    color: #9C7A00;
    background-color: #FFD952;
    border-color: #EECB4E;
}
.FundraiserCard_ended__2DUmf{
    color: #396D51;
    background-color: #9DD1A8;
    border-color: #9AC2A0;
}
.FundraiserCard_label__49vJk{
    display: block;
    color: #1F363D80;
    text-align: center;
    font-size: 14px;
}
.FundraiserCard_value__Xnw7d{
    color: #1F363D;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
.FundraiserCard_progress__mfrJe{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    margin-top: 10px;
}
.FundraiserCard_progressBar__6XbRv{
    height: 8px;
    width: 90%;
    margin-top: 8px;
    background-color: #ECECEC;
    border-radius: 500px;
}
.FundraiserCard_progressMade__svKrE{
    height: 100%;
    width: 100%;
    background: linear-gradient(90deg, #BC4749 0%, #FFEC41 49%, #A7C957 100%);
    border-radius: 500px;
}
.FundraiserCard_firstInfoRow__65sd4{
    display: flex;
    width: 100%;
    margin-top: 20px;
}
.FundraiserCard_startAt__z2K4i, .FundraiserCard_endAt__I9P0j{
    min-width: 50%;
    text-align: center;
}
.FundraiserCard_endAt__I9P0j{
    margin-left: auto;
}
.FundraiserCard_secondInfoRow__1mLUp{
    margin-top: 20px;
}
.FundraiserCard_totalDonations__L6VPy, .FundraiserCard_requestStatus__AUg8W{
    min-width: 50%;
}
.FundraiserCard_totalDonations__L6VPy{
    text-align: center;
}
.FundraiserCard_showRequestStatus__OTxuA{
    display: flex;
    width: 100%;
}
.FundraiserCard_requestStatus__AUg8W{
    margin-left: auto;
    text-align: center;
}
.FundraiserCard_requested__GgOCJ{
    color: #FF9900;
}
.FundraiserCard_approved__\\+B5gN{
    color: #29A462;
    text-transform: capitalize;
}
.FundraiserCard_rejected__H-VI4{
    color: #EB443F;
    text-transform: capitalize;
}
.FundraiserCard_clockCircleOrange__dHOEx, .FundraiserCard_checkmarkCircleGreen__DE\\+XJ, .FundraiserCard_xCircleRed__Y7eQg{
    position: relative;
    height: 11px;
    width: 11px;
    margin-right: 5px;
}
.FundraiserCard_clockCircleOrange__dHOEx{
    top: 0.5px;
}
.FundraiserCard_checkmarkCircleGreen__DE\\+XJ{
    top: 1px;
}
.FundraiserCard_xCircleRed__Y7eQg{
    top: 1px;
}
.FundraiserCard_buttonLink__mVvcD{
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(100% - 64px);
    margin-top: 20px;
    padding: 14px 32px;
    color: #FFFFFF;
    background-color: #40798C;
    text-decoration: none;
    font-size: 14px;
    border: none;
    border-radius: 500px;
}
.FundraiserCard_buttonLink__mVvcD:focus-visible{
    outline: none;
}
.FundraiserCard_moneyCoins__mAdW0{
    height: 20px;
    width: 20px;
    margin-right: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/FundraiserCard.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iCAAiC;IACjC,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,mCAAmC;IACnC,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,UAAU;IACV,eAAe;IACf,yBAAyB;IACzB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,WAAW;IACX,yEAAyE;IACzE,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,WAAW;AACf;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,UAAU;AACd;AACA;IACI,QAAQ;AACZ;AACA;IACI,QAAQ;AACZ;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".container{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 257px;\n    padding: 24px 24px 32px 24px;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.name{\n    max-width: 100%;\n    margin-top: 0;\n    margin-bottom: 8px;\n    text-align: center;\n    color: #40798C;\n    font-size: 16px;\n    font-family: 'Gotham Bold', serif;\n    line-height: 16px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n.requestPendingStatus{\n    margin: 11px 0;\n    color: #EB443F;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n.exclamationCircleRed{\n    position: relative;\n    top: 1px;\n    height: 12px;\n    width: 12px;\n    margin-right: 5px;\n}\n.status{\n    margin-bottom: 10px;\n    padding: 6px 12px;\n    font-size: 12px;\n    font-family: 'Gotham Medium', serif;\n    border: 1px solid;\n    border-radius: 14px;\n}\n.notStarted{\n    color: #40798C;\n    background-color: #ECF2F4;\n    border-color: #DBE6EA;\n}\n.inProgress{\n    color: #9C7A00;\n    background-color: #FFD952;\n    border-color: #EECB4E;\n}\n.ended{\n    color: #396D51;\n    background-color: #9DD1A8;\n    border-color: #9AC2A0;\n}\n.label{\n    display: block;\n    color: #1F363D80;\n    text-align: center;\n    font-size: 14px;\n}\n.value{\n    color: #1F363D;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n.progress{\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 100%;\n    margin-top: 10px;\n}\n.progressBar{\n    height: 8px;\n    width: 90%;\n    margin-top: 8px;\n    background-color: #ECECEC;\n    border-radius: 500px;\n}\n.progressMade{\n    height: 100%;\n    width: 100%;\n    background: linear-gradient(90deg, #BC4749 0%, #FFEC41 49%, #A7C957 100%);\n    border-radius: 500px;\n}\n.firstInfoRow{\n    display: flex;\n    width: 100%;\n    margin-top: 20px;\n}\n.startAt, .endAt{\n    min-width: 50%;\n    text-align: center;\n}\n.endAt{\n    margin-left: auto;\n}\n.secondInfoRow{\n    margin-top: 20px;\n}\n.totalDonations, .requestStatus{\n    min-width: 50%;\n}\n.totalDonations{\n    text-align: center;\n}\n.showRequestStatus{\n    display: flex;\n    width: 100%;\n}\n.requestStatus{\n    margin-left: auto;\n    text-align: center;\n}\n.requested{\n    color: #FF9900;\n}\n.approved{\n    color: #29A462;\n    text-transform: capitalize;\n}\n.rejected{\n    color: #EB443F;\n    text-transform: capitalize;\n}\n.clockCircleOrange, .checkmarkCircleGreen, .xCircleRed{\n    position: relative;\n    height: 11px;\n    width: 11px;\n    margin-right: 5px;\n}\n.clockCircleOrange{\n    top: 0.5px;\n}\n.checkmarkCircleGreen{\n    top: 1px;\n}\n.xCircleRed{\n    top: 1px;\n}\n.buttonLink{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: calc(100% - 64px);\n    margin-top: 20px;\n    padding: 14px 32px;\n    color: #FFFFFF;\n    background-color: #40798C;\n    text-decoration: none;\n    font-size: 14px;\n    border: none;\n    border-radius: 500px;\n}\n.buttonLink:focus-visible{\n    outline: none;\n}\n.moneyCoins{\n    height: 20px;\n    width: 20px;\n    margin-right: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `FundraiserCard_container__EoPnF`,
	"name": `FundraiserCard_name__MEA8m`,
	"requestPendingStatus": `FundraiserCard_requestPendingStatus__KNGmk`,
	"exclamationCircleRed": `FundraiserCard_exclamationCircleRed__ijU4g`,
	"status": `FundraiserCard_status__OfCLQ`,
	"notStarted": `FundraiserCard_notStarted__5znOd`,
	"inProgress": `FundraiserCard_inProgress__4dpkS`,
	"ended": `FundraiserCard_ended__2DUmf`,
	"label": `FundraiserCard_label__49vJk`,
	"value": `FundraiserCard_value__Xnw7d`,
	"progress": `FundraiserCard_progress__mfrJe`,
	"progressBar": `FundraiserCard_progressBar__6XbRv`,
	"progressMade": `FundraiserCard_progressMade__svKrE`,
	"firstInfoRow": `FundraiserCard_firstInfoRow__65sd4`,
	"startAt": `FundraiserCard_startAt__z2K4i`,
	"endAt": `FundraiserCard_endAt__I9P0j`,
	"secondInfoRow": `FundraiserCard_secondInfoRow__1mLUp`,
	"totalDonations": `FundraiserCard_totalDonations__L6VPy`,
	"requestStatus": `FundraiserCard_requestStatus__AUg8W`,
	"showRequestStatus": `FundraiserCard_showRequestStatus__OTxuA`,
	"requested": `FundraiserCard_requested__GgOCJ`,
	"approved": `FundraiserCard_approved__+B5gN`,
	"rejected": `FundraiserCard_rejected__H-VI4`,
	"clockCircleOrange": `FundraiserCard_clockCircleOrange__dHOEx`,
	"checkmarkCircleGreen": `FundraiserCard_checkmarkCircleGreen__DE+XJ`,
	"xCircleRed": `FundraiserCard_xCircleRed__Y7eQg`,
	"buttonLink": `FundraiserCard_buttonLink__mVvcD`,
	"moneyCoins": `FundraiserCard_moneyCoins__mAdW0`
};
export default ___CSS_LOADER_EXPORT___;
